import { render, staticRenderFns } from "./AppReleaseAdd.vue?vue&type=template&id=4da12634&"
import script from "./AppReleaseAdd.vue?vue&type=script&lang=js&"
export * from "./AppReleaseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports